/**
 * Letters and labels (NEW-WF-12, X-01, X-02): `/letters` (`?patient=`,
 * `?tab=labels&kind=patient|carrier|referral`). Printing files the PDF to the
 * patient's Documents.
 */
import { defineManifest } from '@velora/contracts';
import { LETTERS_PERMISSIONS as P } from '@velora/contracts/letters';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'letters',
    title: 'Letters and labels',
    version: '0.1.0',
    owner: 'WP4-LETTERS',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'letters',
        path: '/letters',
        title: 'Letters and labels',
        officeScope: 'location',
        permission: P.view,
        readsPhi: true,
      },
    ],
    commands: [
      {
        id: 'letters.open',
        title: 'Letters and labels',
        keywords: ['letter', 'quick letters', 'label', 'avery', 'dymo', 'recall letter', 'welcome'],
        routeId: 'letters',
        permission: P.view,
      },
    ],
    sseEntityKeys: ['document'],
    phiReadPoints: ['letters.preview', 'letters.labels'],
  }),
  pages: {
    letters: () => import('./LettersPage.js'),
  },
});
